module.exports = new __parcel__URL__("holyflash.eccbe40a.png").toString();